module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "steps-container"
    }
  }, [_c('div', {
    staticClass: "ui four column container centered grid fixed"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "ui fluid steps unstackable"
  }, [_c('div', {
    staticClass: "active step column"
  }, [_c('i', {
    staticClass: "in cart icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content mobile below hidden"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Cart")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.lang.say('SHOPPING_FLOW_CART_DESC')))])])]), _vm._v(" "), _c('div', {
    staticClass: "disabled step column"
  }, [_c('i', {
    staticClass: "truck icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content mobile below hidden"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Shipping")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.lang.say('SHOPPING_FLOW_SHIPPING_DESC')))])])]), _vm._v(" "), _c('div', {
    staticClass: "disabled step column"
  }, [_c('i', {
    staticClass: "payment icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content mobile below hidden"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Billing")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.lang.say('SHOPPING_FLOW_PAYMENT_DESC')))])])]), _vm._v(" "), _c('div', {
    staticClass: "disabled step column"
  }, [_c('i', {
    staticClass: "info icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content mobile below hidden"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Confirm")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.lang.say('SHOPPING_FLOW_CONFIRM_DESC')))])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-72a224c2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/StepBar.vue
// module id = 379
// module chunks = 0